<template>
  <div>
    <div class="col float-right">
      <q-btn-group outline>
        <q-btn v-if="tabParam.documentStatusCd && editable && !checkEnvKind" class="custom-btn" label="QR 코드" icon="qr_code_scanner" color="black" size="md">
          <q-popup-proxy>
            <c-card title="QR 코드 출력" class="cardClassDetailForm">
              <template slot="card-button">
                <c-btn label="인쇄" icon="print" @btnClicked="print" />
              </template>
              <template slot="card-detail">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="wrap" action="#" id="printJS-form">
                      <vue-qrcode
                        :value="serverName+'/sop/edu/result/educationResult?eduEducationId='
                        + param.eduEducationId" 
                        :options="{ width: 180 }"
                        class="canvas"
                      >
                      </vue-qrcode>
                      <span class="facilityStyle">
                        <p class="abc" >
                          <b>{{'-교육명 : '}}</b>{{tabParam.educationName}}
                          <br>
                          <b>{{'-교육일시 : '}} </b>{{tabParam.educationDate}}
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </c-card>
          </q-popup-proxy>
        </q-btn>
        <!-- <c-btn  v-show="editable&&!disabled" :showLoading="false" label="교육계획결재" icon="save" color="blue" @btnClicked="planAppr" /> -->
        <c-btn v-show="editable&&param.eduEducationId" label="삭제" icon="delete_forever"
                    :auth="param.delAuth" @btnClicked="remove" />
        <c-btn  v-show="editable&&!disabled" :showLoading="false" icon="check" label="완료"  @btnClicked="planComplete('COMPLETE')" />
      </q-btn-group>
    </div>
    <c-tab
      type="vertical"
      :tabItems="tabItems"
      :height.sync="tabHeight"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :tabParam="tabParam"
          :param.sync="param"
          @transInfo="transInfo"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
import { uid } from 'quasar'
import printJs from 'print-js'
import selectConfig from '@/js/selectConfig';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'education-plan-tab',
  components: {
    VueQrcode
  },
  props: {
    param: {
      type: Object,
      default: () => ({
        plantCd: null,
        eduEducationId: '',
        completeSt: '',
        documentStatusCd: '',
        educationKindCdLarge: null,
        delAuth: '',
      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
  data() {
    return {
      tabParam: {
        eduEducationId: '',
        eduEducationYearPlanId: '',
        educationName: '',
        eduCourseId: '',
        plantCd: '',
        educationYear: '',
        educationCourseName: '',
        educationKindCdLarge: null,
        educationKindCdSmall: null,
        educationTypeCd: null,
        departmentDeptCd: '',
        legalEducationFlag: null,
        educationTime: '',
        educationCycle: null,
        educationPurpose: '',
        relationLaws: '',
        mainTargetAudience: '',
        educationMonth: null,
        educationLocation: '',
        estimatedEducationExpenses: '',
        executionBudget: '',
        educationStartDate: '',
        educationEndDate: '',
        educationStartTime: '',
        educationEndTime: '',
        instructorInformation: '',
        sopMocId: '',
        educationMethodCd: null,
        educationOverview: '',
        evaluationEvalCd: '',
        sumEducationTime: '',
        documentStatusCd: '',
        qrCodeRoute: '',
        checkAppr: '',
        regUserId: '',
        oriUserId: '',
        chgUserId: '',
        eduSubjectList: [], // 과정별 교육과목
        eduAttendeeList: [],
      },
      saveCall: {
        saveCallData: '',
      },
      editable: true,
      splitter: 5,
      tab: 'educationPlanInfo',
      isComplete: false,
      serverName: '',
      insertUrl: '',
      deleteUrl: '',
      updateUrl: '',
      tabItems: [],
    };
  },
  computed: {
    tabHeight() {
      let numHeight = this.height ? Number(this.$_.replace(this.height, 'px', '')) : 600;
      numHeight = numHeight - 40
      return numHeight + 'px';
    },
    disabled() {
      return this.tabParam.documentStatusCd !== 'ESC000001'
    },
    isOwner() {
      return this.tabParam.documentStatusCd !== 'ESC000010' && this.tabParam.oriUserId === this.$store.getters.user.userId;
    },
    checkEnvKind() {
      return this.tabParam.educationKindCdLarge === 'EKFC000002'
    },
  },
  watch: {
    'param.completeSt'() {
      if (this.param.documentStatusCd) {
        this.$set(this.tabParam, 'documentStatusCd', this.param.documentStatusCd)
      }
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // role setting
      this.redirectUrl = selectConfig.mdm.equipment.qrUrl.url;
      // url setting
      this.insertUrl = transactionConfig.sop.edu.plan.insert.url;
      this.updateUrl = transactionConfig.sop.edu.plan.update.url;
      this.deleteUrl = transactionConfig.sop.edu.plan.delete.url;
      this.completeUrl = transactionConfig.sop.edu.annual.complete.url;
      // code setting
      if (this.param.eduEducationId) {
        this.tabItems = [
          { key: uid(), name: 'educationPlanInfo', icon: 'edit', label: '기본정보', component: () => import(`${'./educationPlanInfo.vue'}`) },
          { key: uid(), name: 'educationResultTargetUser', icon: 'how_to_reg', label: '교육대상자', component: () => import(`${'./educationResultTargetUser.vue'}`), disabled: false },
          // { key: uid(), name: 'educationTextBook', icon: 'checklist', label: '교육교재', component: () => import(`${'./educationTextBook.vue'}`), disabled: false },
        ]
      } else {
        this.tabItems = [
          { key: uid(), name: 'educationPlanInfo', icon: 'edit', label: '기본정보', component: () => import(`${'./educationPlanInfo.vue'}`) },
          { key: uid(), name: 'educationResultTargetUser', icon: 'how_to_reg', label: '교육대상자', component: () => import(`${'./educationResultTargetUser.vue'}`), disabled: true },
          // { key: uid(), name: 'educationTextBook', icon: 'checklist', label: '교육교재', component: () => import(`${'./educationTextBook.vue'}`), disabled: true },
        ]
      }
      // list setting
      this.serverUrl();
    },
    serverUrl() {
      this.$http.url = this.redirectUrl;
      this.$http.type = 'GET';
      this.$http.param = {};
      this.$http.request(
        _result => {
          this.serverName = _result.data
        },
        _error => {
          window.getApp.$emit('APP_REQUEST_ERROR', _error);
        }
      );
    },
    print() {
      printJs({
        printable: 'printJS-form',
        type: 'html',
        font_size: '20px',
        targetStyles: ['*'],
      })
    },
    transInfo(data) {
      this.tabParam = data;
      if (data.eduEducationId) {
        this.tabItems = [
          { key: uid(), name: 'educationPlanInfo', icon: 'edit', label: '기본정보', component: () => import(`${'./educationPlanInfo.vue'}`) },
          { key: uid(), name: 'educationResultTargetUser', icon: 'how_to_reg', label: '교육대상자', component: () => import(`${'./educationResultTargetUser.vue'}`), disabled: false },
          // { key: uid(), name: 'educationTextBook', icon: 'checklist', label: '교육교재', component: () => import(`${'./educationTextBook.vue'}`), disabled: false },
        ]
      }
    },
    planComplete(type) {
      let content = '';
      if (type === 'COMPLETE') content = '계획완료'
      else content = '결재'
      let flag = false;
      if (!flag) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: content + '하시겠습니까?(저장과 함께 처리됩니다.)',
          // TODO : 점검완료 하시겠습니까?
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.tabParam.documentStatusCd = 'ESC000005'
            this.$http.url = this.completeUrl;
            this.$http.type = 'PUT';
            this.$http.param = this.tabParam;
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.saveCall.saveCallData = uid();
              if (this.tabParam.documentStatusCd === 'ESC000005') {
                this.$emit('emitStep', {
                  name: 'currentStep',
                  param: {
                    step: 'ESC0000010', // 교육결과로 이동
                    key: this.param.eduEducationId, // key
                  }
                })
              }
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
      });
      }
    },
    /* eslint-disable no-unused-vars */ 
    remove() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '등록된 모든 교육계획/결과/이수자 정보가 완전 삭제됩니다.\n\r삭제된 데이터는 복구할 수 없습니다.\n\r그래도 삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.param.eduEducationId);
          this.$http.type = 'DELETE';
          this.$http.request((_result) => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            
            this.$emit('emitStep', {
              name: 'closePopup',
              param: {},
            })
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
  }
};
</script>
